var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showDialog ? _c('div', {
    staticClass: "dialog",
    class: [!_vm.isPC ? 'dialog-h5' : '', _vm.center ? 'center' : ''],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleView(_vm.clickType.OUTSIDE);
      }
    }
  }, [_c('main', {
    staticClass: "dialog-main",
    class: [!_vm.backgroundDialog ? 'dialog-main-back' : ''],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleView(_vm.clickType.INSIDE);
      }
    }
  }, [_vm.isHeaderShowDialog ? _c('header', {
    staticClass: "dialog-main-header"
  }, [_c('h1', {
    staticClass: "dialog-main-title"
  }, [_vm._v(" " + _vm._s(_vm.showTitle) + " ")]), _c('i', {
    staticClass: "icon icon-close",
    on: {
      "click": _vm.close
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "dialog-main-content",
    class: [_vm.isH5 ? 'dialog-main-content-uniapp' : '']
  }, [_vm._t("default")], 2), _vm.isFooterShowDialog ? _c('footer', {
    staticClass: "dialog-main-footer"
  }, [_c('button', {
    staticClass: "btn btn-cancel",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t('取消')) + " ")]), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t('确定')) + " ")])]) : _vm._e()])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }